<div [formGroup]="form" class="flex justify-stretch h-full *:flex-1" [ngSwitch]="controlMetadata.userInputType">
  <!-- Lots of duplicated label HTML here to keep *ngSwitchCase on mat-form-field. 
    Bad things happen if a mat-form-field is nested or created without a Material form input due to composition issues.-->
    
  <mat-form-field *ngSwitchCase="InputType.TextField" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%]">
    <label>
      <app-icon *ngIf="required" icon="asterisk" aria-hidden="true" size="10"></app-icon>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <input type="text" matInput appNoHtmlTags trim [formControlName]="controlMetadata.name">
    <mat-error>
      <span *ngIf="formControl.errors?.['required']">{{ controlMetadata.friendlyName }} required. </span>
      <span *ngIf="formControl.errors?.['invalidIpAddress']">{{ controlMetadata.friendlyName }} is invalid. </span>
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.PasswordField" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%]">
    <label>
      <app-icon *ngIf="required" icon="asterisk" aria-hidden="true" size="10"></app-icon>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <input class="text-security-disc" matInput appNoHtmlTags trim [formControlName]="controlMetadata.name">
    <mat-error>
      <span *ngIf="formControl.errors?.['required']">{{ controlMetadata.friendlyName }} required. </span>
    </mat-error>
  </mat-form-field>

  <div *ngSwitchCase="InputType.CheckBox" floatLabel="never" class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%]">
    <mat-form-field>
      <label>
        <app-icon *ngIf="required" icon="asterisk" aria-hidden="true" size="10"></app-icon>
        {{ controlMetadata.friendlyName }}
        <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
      </label>
      <input class="!hidden" matInput>
      <mat-slide-toggle class="mt-3 w-full" [formControlName]="controlMetadata.name"></mat-slide-toggle>
    </mat-form-field>
  </div>

  <mat-form-field *ngSwitchCase="InputType.MultiSelect" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%]">
    <label>
      <app-icon *ngIf="required" icon="asterisk" aria-hidden="true" size="10"></app-icon>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>

    <!-- Dynamic options (fetched from API) -->
    <ng-container *ngIf="isDynamic; else staticOptions">
      <mat-select
        [formControlName]="controlMetadata.name"
        [disabled]="dynamicOptionsLoading || (!dynamicOptionsFetched && (controlMetadata.dependsOn?.length > 0))"
        [placeholder]="dynamicPlaceholder"
        (selectionChange)="onDynamicOptionSelected($event.value)">
        <mat-option *ngFor="let option of dynamicOptions" [value]="option.label + '||' + option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="staleOptionLabel" class="text-orange-600">
        Previously selected: {{ staleOptionLabel }} — this option is no longer available
      </mat-hint>
    </ng-container>

    <!-- Static options (existing behavior) -->
    <ng-template #staticOptions>
      <mat-select [formControlName]="controlMetadata.name">
        <mat-option *ngFor="let option of controlMetadata.options" [value]="option">{{ option }}</mat-option>
      </mat-select>
    </ng-template>

    <mat-error>
      <span *ngIf="formControl.errors?.['required']">{{ controlMetadata.friendlyName }} required. </span>
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.SiteDropdown" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%]">
    <label>
      <app-icon *ngIf="required" icon="asterisk" aria-hidden="true" size="10"></app-icon>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <app-site-select *ngSwitchCase="InputType.SiteDropdown" [disabled]="mode === InputMode.Edit" [form]="form" [controlName]="controlMetadata.name"
      [organizationId]="organizationId" (siteSelected)="onSiteSelectedFromChild($event)"></app-site-select>
    <input class="!hidden" matInput>
    <div *ngIf="formControl.status === 'INVALID' && formControl.touched" class="mat-mdc-form-field-error mat-mdc-form-field-subscript-wrapper pt-1">
      <span *ngIf="formControl.errors?.['NoOptionsError']">No customer number to provision. </span>
      <span *ngIf="formControl.errors?.['required']">Customer number required. </span>
      <span *ngIf="formControl.errors?.['InvalidOptionError']">Customer number is invalid. </span>
    </div>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.SystemDropdown" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%]">
    <label>
      <app-icon *ngIf="required" icon="asterisk" aria-hidden="true" size="10"></app-icon>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <app-system-select *ngSwitchCase="InputType.SystemDropdown" [disabled]="mode === InputMode.Edit" [form]="form" [controlName]="controlMetadata.name"
      [siteId]="form.get('siteId').value" [mode]="mode" [systemType]="systemType"
      (provisionStatusChange)="onProvisionStatusChange($event)"></app-system-select>
    <input class="!hidden" matInput>
    <div *ngIf="formControl.status === 'INVALID' && formControl.touched" class="mat-mdc-form-field-error mat-mdc-form-field-subscript-wrapper pt-1">
      <span *ngIf="formControl.errors?.['NoOptionsError']">No serial number to provision. </span>
      <span *ngIf="formControl.errors?.['required']">Serial number required. </span>
      <span *ngIf="formControl.errors?.['InvalidOptionError']">Serial number is invalid. </span>
    </div>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.EdgeDeviceDropdown" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%]">
    <label>
      <app-icon *ngIf="required" icon="asterisk" aria-hidden="true" size="10"></app-icon>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <app-edge-device-select [disabled]="mode === InputMode.Edit" [form]="form" [controlName]="controlMetadata.name"
      [peerControlNames]="edgeDeviceDropdownNames">
    </app-edge-device-select>
    <input class="!hidden" matInput>
    <div *ngIf="formControl.status === 'INVALID' && formControl.touched" class="mat-mdc-form-field-error mat-mdc-form-field-subscript-wrapper pt-1">
      <span *ngIf="formControl.errors?.['NoOptionsError']">No available devices found. </span>
      <span *ngIf="formControl.errors?.['required']">{{ controlMetadata.friendlyName }} required. </span>
      <span *ngIf="formControl.errors?.['InvalidOptionError']">Selection is invalid. </span>
    </div>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.IncadaTenantSlugDropdown" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%] readonly-field">
    <label>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <input type="text" matInput [formControlName]="controlMetadata.name" readonly>
    <mat-hint *ngIf="!formControl.value">Select an Incada-enabled organization</mat-hint>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.IncadaTenantIdDropdown" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%] readonly-field">
    <label>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <input type="text" matInput [formControlName]="controlMetadata.name" readonly>
    <mat-hint *ngIf="!formControl.value">Select an Incada-enabled organization</mat-hint>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.IncadaRegionDropdown" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%] readonly-field">
    <label>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <input type="text" matInput [formControlName]="controlMetadata.name" readonly>
    <mat-hint *ngIf="!formControl.value">Select an Incada-enabled organization</mat-hint>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="InputType.IncadaLocationSlugDropdown" floatLabel="never"
    class="xs:basis-1/5 sm:basis-1/5 gt-sm:basis-[30%] readonly-field">
    <label>
      {{ controlMetadata.friendlyName }}
      <custom-tooltip [text]="controlMetadata.description"></custom-tooltip>
    </label>
    <input type="text" matInput [formControlName]="controlMetadata.name" readonly>
    <mat-hint *ngIf="!formControl.value && !formControl.errors?.['notIncadaEnabled']">Select a site first</mat-hint>
    <mat-error *ngIf="formControl.errors?.['notIncadaEnabled']">The selected site is not Incada-enabled</mat-error>
  </mat-form-field>

  <span *ngSwitchDefault class="flex justify-center self-center italic text-red-600">{{controlMetadata.userInputType}}
    not found</span>
</div>